export default "__VITE_ASSET__BQmAqJwt__"